/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";

const StyledTreeItem = styled.div`
  display: grid;
  gap: 1rem;
  padding: 0.25rem;

  ${({ theme }) => theme.containerMedia.sm} {
    padding: 0;
  }
`;

const TreeItem = ({ children, ...props }) => {
  return <StyledTreeItem {...props}>{children}</StyledTreeItem>;
};

export default TreeItem;
